module.exports = __webpack_public_path__ + "static/Pavillions_pin-47c77f6fd2ef151beec5305cbe7566ec.png";